module.exports = __webpack_public_path__ + "img/1440.a1234c54.jpg";